module.exports = __webpack_public_path__ + "static/media/Computer.5d21247e.png";